<app-card>
  <div class="flex flex-col gap-8 items-stretch">
    <div class="flex flex-nowrap gap-1 w-full">
      <app-input class="flex-grow" [formControl]="searchControl" placeholder="{{ 'page.projects.list.search.placeholder' | translate }}" icon="/assets/images/icon-search.svg"></app-input>
      <app-select class="w-52" [options]="sortOptions" [formControl]="sortControl" label="{{ 'table.sort-by' | translate }}"></app-select>
    </div>
    <app-table [columns]="columns" [data]="data$ | async" (pageChange)="changePage($event)"></app-table>
  </div>
</app-card>
